import {
  GamoraFoundationAdapter,
  GamoraFoundationGuard,
  GamoraFoundationNodeArgs,
  GamoraFoundationNodeChildMap,
  GamoraStoreDefaultNode,
} from '@ver.id/libs.internal.gamora';
import { IHoruz } from '../../../horuz.js';

/**
 * Args
 * @public
 */
export interface HoruzProtocolChulakStoreBaseNodeArgs<
  TChildMap extends GamoraFoundationNodeChildMap<TChildMap>,
> extends GamoraFoundationNodeArgs<TChildMap> {
  adapter: GamoraFoundationAdapter;
}

/**
 * GrootOAuthClientNode
 * @public
 */
export abstract class HoruzProtocolChulakStoreBaseNode<
  TSubject extends GamoraFoundationGuard,
  TRoot extends IHoruz,
  TChildMap extends GamoraFoundationNodeChildMap<TChildMap>,
> extends GamoraStoreDefaultNode<
  GamoraFoundationAdapter,
  TSubject,
  TRoot,
  TChildMap
> {
  /**
   * Constructor
   */
  constructor(args: HoruzProtocolChulakStoreBaseNodeArgs<TChildMap>) {
    super({
      adapter: args.adapter,
    });
  }
}
